import styled from "styled-components";
import { Flex, Title, Image } from "@mantine/core";
import { ContentContainer } from "../../components/container/ContentContainer";
import { stakeholderList } from "../../data/stakeholderList";
import { useMediaQuery } from "@mantine/hooks";

const LogoContainer = styled(Flex)`
	width: 1200px;
	flex-direction: column;
	border-radius: 24px;
	padding: 24px;
	@media only screen and (max-width: 750px) {
		border-radius: 16px;
		width: 100%;
		padding: 20px 8px;
	}
`;

export const StakeHolderSection = ({ theme = "light" }) => {
	const isMobile = useMediaQuery("(max-width: 750px)");

	return (
		<Flex direction="column" align="center" w="100%">
			<ContentContainer>
				<Flex direction="column" align="center" w="100%" gap={isMobile ? 24 : 48} p={isMobile ? 24 : 0}>
					<Title
						order={isMobile ? 4 : 2}
						size={isMobile ? 22 : 36}
						ta="center"
						lh={isMobile ? "36px" : "64px"}
						c={theme === "light" ? "black" : "white"}
					>
						금융시장의 변화를 함께 만드는
						<br />
						어니스트AI의 주주를 소개합니다
					</Title>

					<LogoContainer bg={theme === "light" ? "white" : "#020616"}>
						<Flex
							wrap="wrap"
							justify="center"
							style={isMobile ? { rowGap: 16, columnGap: 0 } : { rowGap: 86, columnGap: 0 }}
						>
							{stakeholderList.map((s) => (
								<Flex
									w={isMobile ? "50%" : "25%"}
									style={!isMobile ? { flex: '1 0 auto' } : undefined}
									justify="center"
									align="center"
									key={s.id}
								>
									<Image
										h={isMobile ? "auto" : 95}
										w={isMobile ? "100%" : "auto"}
										src={s.logo[theme]}
										alt={s.name}
									/>
								</Flex>
							))}
						</Flex>
					</LogoContainer>
				</Flex>
			</ContentContainer>
		</Flex>
	);
};
